import { BreadcrumbPassThrough } from 'primeng/breadcrumb';

export const BreadcrumbTelekomPT = (tsKeys: Record<string, string>): BreadcrumbPassThrough => ({
  homeItem: { 'aria-label': tsKeys['HOME'] },
});
